"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.commonDataEpics = exports.loadCommonDataWithCountries = void 0;

var _operators = require("rxjs/operators");

var _rxjs = require("rxjs");

var _utils = require("@alycecom/utils");

var _services = require("@alycecom/services");

var actions = _interopRequireWildcard(require("./commonData.actions"));

var CommonDataRequests;

(function (CommonDataRequests) {
  CommonDataRequests[CommonDataRequests["loadCommonData"] = 0] = "loadCommonData";
  CommonDataRequests[CommonDataRequests["loadCountries"] = 1] = "loadCountries";
  CommonDataRequests[CommonDataRequests["loadAvailableCountriesIds"] = 2] = "loadAvailableCountriesIds";
})(CommonDataRequests || (CommonDataRequests = {}));

var loadCommonDataWithCountries = function loadCommonDataWithCountries(action$, state$, _ref) {
  var createGiftService = _ref.createGiftService;
  return action$.pipe((0, _utils.ofType)(actions.commonLoadRequest), (0, _operators.switchMap)(function () {
    var loadCommonData = createGiftService.getCommonData();
    var loadCountries = createGiftService.getCountries();
    var loadAvailableCountriesIds = createGiftService.getAvailableCountriesIds();
    return (0, _rxjs.forkJoin)([loadCommonData, loadCountries, loadAvailableCountriesIds]).pipe((0, _operators.mergeMap)(function (responses) {
      var commonDataResponse = responses[CommonDataRequests.loadCommonData];
      var _ref2 = responses[CommonDataRequests.loadCountries],
          countries = _ref2.data;
      var _ref3 = responses[CommonDataRequests.loadAvailableCountriesIds],
          availableCountriesIds = _ref3.data;
      return [actions.commonLoadSuccess(commonDataResponse), actions.setCountries({
        countries,
        usaStates: commonDataResponse.usa_states
      }), actions.setAvailableCountriesIds(availableCountriesIds)];
    }), (0, _operators.catchError)((0, _services.handleError)(_services.handlers.handleAnyError(actions.commonLoadFail))));
  }));
};

exports.loadCommonDataWithCountries = loadCommonDataWithCountries;
var commonDataEpics = [loadCommonDataWithCountries];
exports.commonDataEpics = commonDataEpics;